import { highlightText } from '@common';
import React, { useCallback, useMemo, useState } from 'react';
import './SpeakerTranscriptResults.scss';

interface SpeakerTranscriptResultsProps {
    speakerName: string;
    rows: string[];
}

const highlightRe = /<b>([^<]*)<\/b>/g;

const MAX_ELEMENTS = 3;

function SpeakerTranscriptResults(props: SpeakerTranscriptResultsProps): JSX.Element {
    const {
        speakerName,
        rows
    } = props;

    const [expanded, setExpanded] = useState<boolean>(false);
    
    const utts = useMemo(() => {
        const renderRows = expanded ? rows : rows.slice(0, MAX_ELEMENTS);
        return renderRows.sort((a, b) => a['StartTicks'] - b['StartTicks']).map((row, ix) => <div className='speaker_transcript_result__utt' key={ix}>
                {highlightText(row['Text'], highlightRe)}
            </div>);
    }, [rows, expanded]);

    const onExpandClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        setExpanded(true);
    }, []);
    

	return <div className='speaker_transcript_result'>
            <div className='speaker_transcript_result__speaker'>{speakerName}</div>
            <div className='speaker_transcript_result__utts'>{utts}</div>
            {rows.length > MAX_ELEMENTS && !expanded && <div className='speaker_transcript_result__expand' onClick={onExpandClick}>Всего {rows.length}</div>}
    </div>
}

export {SpeakerTranscriptResults};